<div [formGroup]="ckForm">
    <jodit-editor [config]="configs" #editor [formControlName]="field"></jodit-editor>
</div>
